module.exports = __webpack_public_path__ + "img/Orb_Label_Text_General.d492a8f8.png";